var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatedMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.41V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V20L4 16H7.29C7.77057 17.6114 8.81507 18.996 10.2325 19.9007C11.65 20.8053 13.3457 21.1696 15.0096 20.9268C16.6735 20.6841 18.1945 19.8506 19.2944 18.5787C20.3944 17.3068 20.9998 15.6815 21 14C21 12.69 20.63 11.46 20 10.41ZM3.17 14L2 15.17V2H18V8.26C16.8279 7.43873 15.4312 6.99876 14 7C12.1 7 10.37 7.77 9.11 9H4V11H7.69C7.25 11.91 7 12.93 7 14H3.17ZM14 18.85C11.32 18.85 9.15 16.68 9.15 14C9.15 11.32 11.32 9.15 14 9.15C16.67 9.15 18.85 11.32 18.85 14C18.85 16.68 16.67 18.85 14 18.85ZM16 7H4V5H16V7ZM14.5 13.82L16.94 15.23L16.19 16.53L13 14.69V11H14.5V13.82Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedMessage);
export default __webpack_public_path__ + "static/media/automated-message.7b41a6e93baaf30db17190e9102d4e59.svg";
export { ForwardRef as ReactComponent };